import axiosClient from "../shared/api/axios-client";

/**
 * Interface para resposta do estudante a um exercício
 */
export interface StudentExerciseAnswer {
  exerciseId: string;
  studentAnswerData: string; // JSON com a resposta
  studentAnswerIsCorrect: boolean;
  studentAnswerFeedback: string;
  studentAnsweredAt: string; // ISO 8601 date string
}

/**
 * API para carregar respostas do estudante para exercícios de um módulo
 * GET /api/students/modules/{moduleId}/exercises/student-answers
 */
export const apiGetStudentExerciseAnswers = async (
  moduleId: string
): Promise<StudentExerciseAnswer[]> => {
  try {
    const response = await axiosClient.get<StudentExerciseAnswer[]>(
      `/students/modules/${moduleId}/exercises/student-answers`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching student exercise answers from API:", error);
    throw error;
  }
};

